import { Box, CircularProgress, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useSalesforceOauthCallback } from "@/features/salesforceIntegration/hooks/useSalesforceOauthCallback";

/**
 * Salesforce OAuthコールバック画面（`/auth/callback/on-salesforce`）。
 * Salesforceの外部クライアントアプリケーションに登録するコールバックURL。
 * `code`・`state`をバックエンドへ中継し、成功時は完了画面へ遷移する。
 */
export const SalesforceOauthCallback: React.FC = () => {
  const { state, errorMessage } = useSalesforceOauthCallback();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: 3,
      }}
    >
      {state === "processing" ? (
        <>
          <CircularProgress size={60} />
          <Typography variant="h6" color="text.secondary">
            Salesforceとの連携情報を確認しています...
          </Typography>
        </>
      ) : (
        <>
          <Typography variant="h6" color="error">
            {errorMessage}
          </Typography>
          <Link component={RouterLink} to="/account">
            設定画面に戻る
          </Link>
        </>
      )}
    </Box>
  );
};
